import { Placeholder } from './_Placeholder.js';

export function HardwareSection() {
  return <Placeholder title="Hardware" hint="Stato driver KNX/Glory/Epson/Revolut/WhatsApp" />;
}
